const products = {
    productDataForOverview:[
        {
            id: 1,
            img: 'imges/1.png',
            text: 'Rufle Shirt',
            price: 20
        },
        {
            id: 2,
            img: 'imges/2.png',
            text: 'Herschel supply',
            price: 40
        },
        {
            id: 3,
            img: 'imges/3.png',
            text: 'Check Shirt',
            price: 30
        },
        {
            id: 4,
            img: 'imges/4.png',
            text: 'Classic Coat',
            price: 80
        },
        {
            id: 5,
            img: 'imges/5.png',
            text: 'Cut Shirt',
            price: 20
        },
        {
            id: 6,
            img: 'imges/6.png',
            text: 'Short Shirt',
            price: 40
        },
        {
            id: 7,
            img: 'imges/7.png',
            text: 'Watch',
            price: 30
        },
        {
            id: 8,
            img: 'imges/8.png',
            text: 'Lose Trouser',
            price: 80
        },
        {
            id: 9,
            img: 'imges/9.png',
            text: 'Shoes',
            price: 20
        },
        {
            id: 10,
            img: 'imges/10.png',
            text: 'Shirt and Short',
            price: 40
        },
        {
            id: 11,
            img: 'imges/11.png',
            text: 'Formal Shirt',
            price: 30
        },
        {
            id: 12,
            img: 'imges/12.png',
            text: 'Belt',
            price: 80
        },
    ],
    productDataForAll:[
        {
            id: 1,
            img: 'imges/1.png',
            text: 'Rufle Shirt',
            price: 20,
            catagory: 'women'
        },
        {
            id: 2,
            img: 'imges/2.png',
            text: 'Herschel supply',
            price: 40,
            catagory: 'women'
        },
        {
            id: 3,
            img: 'imges/3.png',
            text: 'Check Shirt',
            price: 30,
            catagory: 'men'
        },
        {
            id: 4,
            img: 'imges/4.png',
            text: 'Classic Coat',
            price: 80,
            catagory: 'women'
        },
        {
            id: 5,
            img: 'imges/5.png',
            text: 'Cut Shirt',
            price: 20,
            catagory: 'women'
        },
        {
            id: 6,
            img: 'imges/6.png',
            text: 'Short Shirt',
            price: 40,
            catagory: 'women'
        },
        {
            id: 7,
            img: 'imges/7.png',
            text: 'Watch',
            price: 30,
            catagory: 'other'
        },
        {
            id: 8,
            img: 'imges/8.png',
            text: 'Lose Trouser',
            price: 80,
            catagory: 'women'
        },
        {
            id: 9,
            img: 'imges/9.png',
            text: 'Shoes',
            price: 20,
            catagory: 'other'
        },
        {
            id: 10,
            img: 'imges/10.png',
            text: 'Shirt and Short',
            price: 40,
            catagory: 'women'
        },
        {
            id: 11,
            img: 'imges/11.png',
            text: 'Formal Shirt',
            price: 30,
            catagory: 'men'
        },
        {
            id: 12,
            img: 'imges/12.png',
            text: 'Belt',
            price: 80,
            catagory: 'other'
        },
        // {
        //     id: 13,
        //     img: 'imges/1.png',
        //     text: 'Rufle Shirt',
        //     price: 20,
        //     catagory: 'women'
        // },
        // {
        //     id: 14,
        //     img: 'imges/2.png',
        //     text: 'Herschel supply',
        //     price: 40,
        //     catagory: 'women'
        // },
        // {
        //     id: 15,
        //     img: 'imges/3.png',
        //     text: 'Check Shirt',
        //     price: 30,
        //     catagory: 'men'
        // },
        // {
        //     id: 16,
        //     img: 'imges/4.png',
        //     text: 'Classic Coat',
        //     price: 80,
        //     catagory: 'women'
        // },
        // {
        //     id: 17,
        //     img: 'imges/5.png',
        //     text: 'cut Shirt',
        //     price: 20,
        //     catagory: 'women'
        // },
        // {
        //     id: 18,
        //     img: 'imges/6.png',
        //     text: 'Short Shirt',
        //     price: 40,
        //     catagory: 'women'
        // },
        // {
        //     id: 19,
        //     img: 'imges/7.png',
        //     text: 'Watch',
        //     price: 30,
        //     catagory: 'other'
        // },
        // {
        //     id: 20,
        //     img: 'imges/8.png',
        //     text: 'Lose Trouser',
        //     price: 80,
        //     catagory: 'women'
        // },
        // {
        //     id: 21,
        //     img: 'imges/9.png',
        //     text: 'Shoes',
        //     price: 20,
        //     catagory: 'other'
        // },
        // {
        //     id: 22,
        //     img: 'imges/10.png',
        //     text: 'Shirt and Short',
        //     price: 40,
        //     catagory: 'women'
        // },
        // {
        //     id: 23,
        //     img: 'imges/11.png',
        //     text: 'Formal Shirt',
        //     price: 30,
        //     catagory: 'men'
        // },
        // {
        //     id: 24,
        //     img: 'imges/12.png',
        //     text: 'Belt',
        //     price: 80,
        //     catagory: 'other'
        // },
    ]
    

}
    let blogData = [
        {
            img: 'imges/blog 1.png',
            h3: '8 Inspiring Ways to Wear Dresses in the Winter'
        },
        {
            img: 'imges/blog 2.png',
            h3: 'The Great Big List of Men’s Gifts for the Holidays'
        }
    ]
    let aboutData = [
        {
            h3: 'Our Story',
            p: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quia, neque inventore provident adipisci velit voluptates perferendis, beatae ipsa omnis tempora earum reprehenderit architecto odit delectus quae, est dolore accusamus maxime repellat itaque voluptate nesciunt optio. Earum laboriosam, magni totam dolor voluptatum est neque cumque eligendi distinctio iusto, saepe esse sit ipsum ex debitis repudiandae corporis, asperiores culpa optio fugiat deleniti officia? Tempora recusandae dignissimos dolorem cumque totam optio sed quasi facilis impedit? Illum placeat quidem sit. Hic temporibus suscipit molestiae, ipsam quibusdam animi laboriosam odio beatae repellat, vel quae adipisci culpa sequi omnis! Temporibus incidunt culpa, perferendis voluptates eum asperiores officia, pariatur a dignissimos illum dolor corporis laborum adipisci, eius quaerat dicta cumque molestiae saepe illo accusantium sit. Natus, dolorum? Ex voluptates dolor modi eum dignissimos architecto voluptate, aut temporibus magni delectus, expedita recusandae molestiae praesentium facilis laudantium ut quos placeat quaerat impedit, cupiditate veritatis nostrum maiores nihil. Rerum nobis fugit tenetur sapiente, porro magnam est? Commodi perspiciatis amet cupiditate quisquam itaque possimus qui temporibus, blanditiis quod? Architecto nihil consequatur maiores eveniet, labore odit alias. Non minima.',
            img: './imges/about1.png',
            class: 'about-stuff'
        },
        {
            h3: 'Our Mission',
            p: 'Mauris non lacinia magna.Sed nec lobortis dolor.Vestibulum rhoncus dignissim risus, sed consectetur erat.Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.Nullam maximus mauris sit amet odio convallis, in pharetra magna gravida.Praesent sed nunc fermentum mi molestie tempor.Morbi vitae viverra odio.Pellentesque ac velit egestas, luctus arcu non, laoreet mauris.Sed in ipsum tempor, consequat odio in, porttitor ante.Ut mauris ligula, volutpat in sodales in, porta non odio.Pellentesque tempor urna vitae mi vestibulum, nec venenatis nulla lobortis.Proin at gravida ante.Mauris auctor purus at lacus maximus euismod.Pellentesque vulputate massa ut nisl hendrerit, eget elementum libero iaculis',
            img: './imges/about2.png',
            class: 'flex-direction'
        }
    ]
    let filterData = [
        {
            h2: 'Filter by Price',
            p1: 'All Products',
            p2: '$20-$30',
            p3: '$30-$50',
            p4: '$50-$70',
            p5: '$70-$90'
        },
    ]

export default products;
export {blogData};
export {aboutData};
export {filterData};